import { useCallback, useRef, useState } from 'react';
import { ALL_GROUPS } from '../components/OrderedGroupChips';

export type SelectedGroupIdInfo = {
    isAllScope: boolean;
    scopeKey: string;
    groupId: string | null;
};

export type UseSelectedGroupIdReturn = {
    selectedGroupId: string;
    handleSelectGroup: (groupId: string) => void;
    getCurrentSelectedGroupId: () => SelectedGroupIdInfo;
    getDragSelectedGroupId: () => SelectedGroupIdInfo;
};

export const useSelectedGroupId = (): UseSelectedGroupIdReturn => {
    const [selectedGroupId, setSelectedGroupId] = useState<string>(ALL_GROUPS);
    const selectedGroupIdRef = useRef<string>(ALL_GROUPS);

    const toSelectedGroupIdInfo = useCallback(
        (groupId: string): SelectedGroupIdInfo => {
            const isAllScope = groupId === ALL_GROUPS;
            return {
                isAllScope,
                scopeKey: groupId,
                groupId: isAllScope ? null : groupId,
            };
        },
        []
    );

    const handleSelectGroup = useCallback((groupId: string) => {
        const nextGroupId = String(groupId);
        selectedGroupIdRef.current = nextGroupId;
        setSelectedGroupId(nextGroupId);
    }, []);

    const getCurrentSelectedGroupId = useCallback(
        () => toSelectedGroupIdInfo(selectedGroupId),
        [selectedGroupId, toSelectedGroupIdInfo]
    );

    const getDragSelectedGroupId = useCallback(
        () => toSelectedGroupIdInfo(selectedGroupIdRef.current),
        [toSelectedGroupIdInfo]
    );

    return {
        selectedGroupId,
        handleSelectGroup,
        getCurrentSelectedGroupId,
        getDragSelectedGroupId,
    };
};
